export default __webpack_public_path__ + "static/media/owner-new.cf615f59.png";